import { Row, Col, Form, Table } from 'react-bootstrap';
import './RescuePlanPageOne.css';
import { RescuePlanPageOne } from '../../../api';
import LabelAndTextBox from '../../molecules/labelandtextbox/LabelAndTextBox';
import YesOrNoCheckbox from '../../molecules/yesornocheckbox/YesOrNoCheckbox';
import DateBox from '../../molecules/labelandtextbox/DateBox';

interface RescuePlanPageOneProps {
  rescuePlanPageOne: RescuePlanPageOne;
  onUpdate?: (updatedData: Partial<RescuePlanPageOne>) => void;
}

const RescuePlanPageOneSection: React.FC<RescuePlanPageOneProps> = (props) => {

  const handleChange = (updatedData: Partial<RescuePlanPageOne>) => {
    props.onUpdate?.(updatedData);
  };

  return (
    <Col className='rescue-plan-page-one'>
      <div className='rescue-section-card rescue-project-info p-3 mb-4'>
        <Row xs={12} lg={3}>
          <DateBox title='Projektstart' defaultValue={props.rescuePlanPageOne?.projectStartDate} onChange={(value) => {
            handleChange({ projectStartDate: value.toISOString() });
          }} />
          <LabelAndTextBox title='Arbetsplats' remark={props.rescuePlanPageOne?.workPlace} onChange={(value) => {
            handleChange({ workPlace: value });
          }} />
          <LabelAndTextBox title='Beställare' remark={props.rescuePlanPageOne?.customerName} onChange={(value) => {
            handleChange({ customerName: value });
          }} />
        </Row>
        <Row xs={12} lg={2} >
          <LabelAndTextBox title='Arbetsgivare' remark={props.rescuePlanPageOne?.employerSTB} onChange={(value) => {
            handleChange({ employerSTB: value });
          }} />
          <LabelAndTextBox title='Arbetsuppgift' remark={props.rescuePlanPageOne?.workAssignment} onChange={(value) => {
            handleChange({ workAssignment: value });
          }} />
        </Row>
      </div>
      <hr />
      <div className='rescue-section-card rescue-emergency-block p-3 mb-4'>
        <h4 className='fw-bold rescue-emergency-title'>Vid Allvarliga olyckor ring 112</h4>
        <Row xs={12} lg={1} className='mt-3 rescue-yesno-list'>
          <div className='rescue-yesno-item'>
            <YesOrNoCheckbox title="1. Finns Arbetsbeskrivning?" approved={props.rescuePlanPageOne?.isThereWorkDescription} radioGroup='isThereWorkDescripion' alignRight showColon={false} useCheckboxModel
              onChange={(check) => {
                handleChange({ isThereWorkDescription: check });
              }} />
          </div>
          <div className='rescue-yesno-item'>
            <YesOrNoCheckbox title='2. Är riskbedömning utförd?' approved={props.rescuePlanPageOne?.isRiskAssesmentDone} radioGroup='isRiskAssesmentDone' alignRight showColon={false} useCheckboxModel
              onChange={(check) => {
                handleChange({ isRiskAssesmentDone: check });
              }} />
          </div>
          <div className='rescue-yesno-item'>
            <YesOrNoCheckbox title='3. Är personlig utrustning kontrollerad och fungerar?' approved={props.rescuePlanPageOne?.isPersonalEquipmentCheckedAndWorking} radioGroup='isPersonalEquipmentCheckedAndWorking' alignRight showColon={false} useCheckboxModel
              onChange={(check) => {
                handleChange({ isPersonalEquipmentCheckedAndWorking: check });
              }} />
          </div>
          <div className='rescue-yesno-item'>
            <YesOrNoCheckbox title='4. Finns högspänningsledare i närheten?' approved={props.rescuePlanPageOne?.isThereHighVoltageConductorsNearby} radioGroup='isThereHighVoltageConductorsNearby' alignRight showColon={false} useCheckboxModel
              onChange={(check) => {
                handleChange({ isThereHighVoltageConductorsNearby: check });
              }} />
          </div>
          <div className='rescue-yesno-item'>
            <YesOrNoCheckbox title='5. Andra möjliga risker som kan påverka ett räddningsförfarande?' approved={props.rescuePlanPageOne?.isThereOtherPossibleSafetyIssues} radioGroup='isThereOtherPossibleSafetyIssues' alignRight showColon={false} useCheckboxModel
              onChange={(check) => {
                handleChange({ isThereOtherPossibleSafetyIssues: check });
              }} />
          </div>
        </Row>
        <Row xs={12} lg={2} className='mt-3'>
          <LabelAndTextBox title='Vad är maximal arbetshöjd?' remark={props.rescuePlanPageOne?.maximalWorkHeight}
            onChange={(value) => {
              handleChange({ maximalWorkHeight: value });
            }} />
          <LabelAndTextBox title='Kommentarer' remark={props.rescuePlanPageOne?.isThereOtherPossibleSafetyIssuesDescription}
            onChange={(value) => {
              handleChange({ isThereOtherPossibleSafetyIssuesDescription: value });
            }} />
        </Row>
      </div>
      <hr />
      <div className=' p-3 mb-4 '>
        <h4 className='fw-bold'>Vilken typ av fallskyddsutrustning används?</h4>
        <Row xs={12} lg={3} className='mt-3 mx-3 mb-3'>
          <Form.Check
            className='checkbox-option fw-bold fs-5'
            type="checkbox"
            defaultChecked={props.rescuePlanPageOne?.fallPreventionSystem}
            label="Fallförhindrandeskydd"
            onChange={(event) => {
              const isChecked = event.target.checked;
              handleChange({ fallPreventionSystem: isChecked });
            }}
          />
          <Form.Check
            className='checkbox-option fw-bold fs-5'
            type="checkbox"
            defaultChecked={props.rescuePlanPageOne?.fallArrestSystem}
            label="Falluppfångandesystem"
            onChange={(event) => {
              const isChecked = event.target.checked;
              handleChange({ fallArrestSystem: isChecked });
            }}
          />
          <Form.Check
            className='checkbox-option fw-bold fs-5'
            type="checkbox"
            defaultChecked={props.rescuePlanPageOne?.supportEquipmentSystem}
            label="Stödutrustningssystem"
            onChange={(event) => {
              const isChecked = event.target.checked;
              handleChange({ supportEquipmentSystem: isChecked });
            }}
          />
        </Row>
        <YesOrNoCheckbox title='Avser arbetsområdet slutna utrymmen/oventilderat utrymme?' approved={props.rescuePlanPageOne?.isThereVentilationInClosedOfSpaces} radioGroup='isThereVentilationInClosedOfSpaces' alignRight showColon={false} useCheckboxModel
          onChange={(check) => {
            handleChange({ isThereVentilationInClosedOfSpaces: check });
          }} />
      </div>
      <hr />
      <div className=' p-3 mb-4 '>
        <h4 className='fw-bold'>Fallskyddsdefinitioner</h4>
        <p className='fs-5'>•Fallförhindrande är ett system som förhindrar en arbetstagare från att fall från ett arbetsläge,<br />
          eller från att röra sig mot en obevakad kant från vilken arbetstagaren kan falla.<br />
          •Falluppfångande är ett system som stoppar en arbetstagares fall innan arbetstagaren traffar ytan under.<br />
          •Stödutrustning är ett system där användaren har spänd(a) lina/linor.
        </p><div className='mt-4'>
          <h4>Kontroll innan arbete kan påbörjas</h4>
          <div className="table-responsive">
            <Table responsive striped bordered hover>
              <thead>
                <tr>
                  <th>Checklista</th>
                  <th>Finns utrustning?</th>
                  <th>Kommentarer</th>
                </tr>
              </thead>
              <tbody>
                <tr className='table-section'>
                  <td>Första hjälpen utrustning<br />Finns i varje fordon</td>
                  <td><input className="checkbox-class" type="checkbox" defaultChecked={props.rescuePlanPageOne?.firstAidEquipment}
                    onChange={() => {
                      handleChange({ firstAidEquipment: !props.rescuePlanPageOne.firstAidEquipment });
                    }} /> </td>
                  <td><input type="placeholder" defaultValue={props.rescuePlanPageOne?.firstAidEquipmentDescription ?? ""}
                    onChange={(event) => {
                      handleChange({ firstAidEquipmentDescription: event.target.value });
                    }} /></td>
                </tr>
                <tr className='table-section'>
                  <td>Rätt skyddsutrustning för arbete<br />Finns i varje fordon</td>
                  <td><input type="checkbox" defaultChecked={props.rescuePlanPageOne?.rightSafetyEquipmentForWork}
                    onChange={() => {
                      handleChange({ rightSafetyEquipmentForWork: !props.rescuePlanPageOne.rightSafetyEquipmentForWork });
                    }} /></td>
                  <td><input type="placeholder" defaultValue={props.rescuePlanPageOne?.rightSafetyEquipmentForWorkDescription ?? ""}
                    onChange={(event) => {
                      handleChange({ rightSafetyEquipmentForWorkDescription: event.target.value });
                    }} /></td>
                </tr>
                <tr className='table-section'>
                  <td>Avspärrning för tredje person<br />Band finns i varje fordon</td>
                  <td><input type="checkbox" defaultChecked={props.rescuePlanPageOne?.blockingForThirdParties}
                    onChange={() => {
                      handleChange({ blockingForThirdParties: !props.rescuePlanPageOne.blockingForThirdParties });
                    }} /></td>
                  <td><input type="placeholder" defaultValue={props.rescuePlanPageOne?.blockingForThirdPartiesDescription ?? ""}
                    onChange={(event) => {
                      handleChange({ blockingForThirdPartiesDescription: event.target.value });
                    }} /></td>
                </tr>
                <tr className='table-section'>
                  <td>Anpassad räddningsutrustning<br />Finns ett per arbetslag</td>
                  <td><input type="checkbox" defaultChecked={props.rescuePlanPageOne?.adaptedRescueEquipment}
                    onChange={() => {
                      handleChange({ adaptedRescueEquipment: !props.rescuePlanPageOne.adaptedRescueEquipment });
                    }} /></td>
                  <td><input type="placeholder" defaultValue={props.rescuePlanPageOne?.adaptedRescueEquipmentDescription ?? ""}
                    onChange={(event) => {
                      handleChange({ adaptedRescueEquipmentDescription: event.target.value });
                    }} /></td>
                </tr>
                <tr className='table-section'>
                  <td>Vem kan hantera Räddningsutrustningen?<br /></td>
                  <td></td>
                  <td><input type="placeholder" defaultValue={props.rescuePlanPageOne?.whoCanHandleSafetyEquipment ?? ""}
                    onChange={(event) => {
                      handleChange({ whoCanHandleSafetyEquipment: event.target.value });
                    }} /></td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      <hr />
    </Col>
  );
};

export default RescuePlanPageOneSection;
